/**
 * PaywallOverlay — modal that shows when the user taps a locked world.
 * The Buy button drives the platform's IAP rail via entitlements.ts:
 *   iOS Capacitor → RevenueCat → StoreKit
 *   Android TWA   → Digital Goods API → Play Billing
 *   Plain web     → 'unsupported' (the parent shows an alert)
 */
interface Props {
  readonly purchasing: boolean;
  readonly onClose: () => void;
  readonly onBuy: () => void;
  readonly onRestore: () => void;
}

export function PaywallOverlay(props: Props) {
  const { purchasing, onClose, onBuy, onRestore } = props;
  return (
    <div id="paywallOverlay" className="overlay">
      <div className="overlayScrim" onClick={purchasing ? undefined : onClose}></div>
      <div className="overlayCard paywall" role="dialog" aria-label="Unlock">
        <header>
          <h2>Unlock all 10 worlds</h2>
          <button
            className="iconBtn ghost"
            aria-label="Close"
            onClick={onClose}
            disabled={purchasing}
          >×</button>
        </header>
        <p className="paywallSub">
          Three worlds — Threshold, Garden, Kitchen — are free forever.
          Unlock the remaining seven for a one-time USD $0.99.
        </p>
        <ul className="paywallList">
          <li>All 10 worlds — 7 more beyond the free three</li>
          <li>Definitions appear under every step you complete</li>
          <li>Plays in English, French, and German</li>
          <li>No subscriptions, no ads, no fishhooks</li>
        </ul>
        <button id="paywallBuy" onClick={onBuy} disabled={purchasing}>
          {purchasing ? 'Processing…' : 'Buy — USD $0.99'}
        </button>
        <button className="ghost" onClick={onRestore} disabled={purchasing}>
          Restore purchase
        </button>
        <p className="paywallNote">
          One-time purchase. Tied to your Apple ID (iOS) or Google account
          (Android) — restore on any device you’re signed in to.
        </p>
      </div>
    </div>
  );
}
